import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL
});

api.interceptors.request.use(request => {

    const token = sessionStorage.getItem('token');
    if (token !== undefined && token !== '') {
        request.headers.Authorization = 'Bearer ' + token;
    }

    return request;
});

api.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response.config.url !== 'auth/login') {
        if (error.response.status === 401) {
            window.location = '/page401';
        }
    }
    return Promise.reject(error);
});

export default api;